import { HistoryItem } from '../history';
import { CustomerLegal } from './customer';
import { CustomerLabel } from './customerLabel';
import z from 'zod';

export const LinkedAccountModel = z.object({
    provider: z.string().nullish(),
    value: z.string().nullish(),
    createdOn: z.string().nullish(),
    deletedOn: z.string().nullish(),
});

export const UserDeviceModel = z.object({
    deviceId: z.string().nullish(),
    approvalDate: z.string().nullish(),
    os: z.string().nullish(),
    version: z.string().nullish(),
    uniqueDeviceId: z.string().nullish(),
    hash: z.string().nullish(),
    linkedAccount: LinkedAccountModel.nullish(),
});

export const CondensedStoreSessionModel = z.object({
    sessionGuid: z.string().nullish(),
    storeGuid: z.string().nullish(),
    createdOn: z.string().nullish(),
    cartId: z.string().nullish(),
});

export const MobileSessionModel = z.object({
    storeGuid: z.string().nullish(),
    lat: z.number().nullish(),
    lon: z.number().nullish(),
    ticketIds: z.string().array().nullish(),
});

export const ExpressSessionModel = z.object({
    storeGuid: z.string().nullish(),
    sessionGuid: z.string().nullish(),
});

export const TagAction = z.enum(['None', 'Set', 'Remove']);

export const TagHistoryModel = z.object({
    action: TagAction.nullish(),
    user: z.string().nullish(),
    ts: z.string().nullish(),
    comment: z.string().nullish(),
});

export const TagModel = z.object({
    createdOn: z.string().nullish(),
    deletedOn: z.string().nullish(),
    modifiedOn: z.string().nullish(),
    name: z.string().nullish(),
    history: TagHistoryModel.array().nullish(),
    version: z.string().nullish(),
});

export const Token = z.object({
    type: z.string().nullish(),
    createdOn: z.string().nullish(),
    value: z.string().nullish(),
    deletedOn: z.string().nullish(),
});

export const TutorialSettings = z.object({
    lastClosed: z.string().nullish(),
});

export const SavedSearchModel = z.object({
    createdOn: z.string().nullish(),
    itemId: z.string().nullish(),
    modifiedOn: z.string().nullish(),
});

export const CustomerCardModel = z.object({
    type: z.string().nullish(),
    value: z.string().nullish(),
    createdOn: z.string().nullish(),
    modifiedOn: z.string().nullish(),
    deletedOn: z.string().nullish(),
});

export const UserModel = z.object({
    userGuid: z.string().nullish(),
    storeGuid: z.string().nullish(),
    hash: z.string().nullish(),
    customerNumber: z.int().nullish(),
    devices: UserDeviceModel.array().nullish(),
    linkedShoppingListUserGuid: z.string().nullish(),
    openStoreSessions: CondensedStoreSessionModel.array().nullish(),
    shoppingListFollowers: z.string().array().nullish(),
    totalSessionStartCount: z.int().nullish(),
    totalSessionPaidCount: z.int().nullish(),
    totalStoreSessionStartCount: z.record(z.string(), z.int()).nullish(),
    totalStoreSessionPaidCount: z.record(z.string(), z.int()).nullish(),
    labels: CustomerLabel.array().nullish(),
    createdOn: z.string().nullish(),
    modifiedOn: z.string().nullish(),
    deletedOn: z.string().nullish(),
    session: MobileSessionModel.nullish(),
    expressSession: ExpressSessionModel.nullish(),
    lastLogin: z.string().nullish(),
    lat: z.number().nullish(),
    lon: z.number().nullish(),
    legal: CustomerLegal.array().nullish(),
    tags: TagModel.array().nullish(),
    isCustomerVerifiedBasket: z.boolean().nullish(),
    tokens: Token.array().nullish(),
    linkedAccounts: LinkedAccountModel.array().nullish(),
    settings: z.record(z.string(), z.unknown()).nullish(),
    tutorialSettings: z.record(z.string(), TutorialSettings).nullish(),
    savedSearches: SavedSearchModel.array().nullish(),
    history: HistoryItem.array().nullish(),
    customerCards: CustomerCardModel.array().nullish(),
});
export type UserModel = z.infer<typeof UserModel>;
